// extracted by mini-css-extract-plugin
export default {"wrapper":"IconAvatar_wrapper__58Dv7","text":"IconAvatar_text__54kYe"};